import { LocaleCurrency } from 'types/Shared/Locale'
import {
  convertDefaultToLocaleCurrency,
  formatNumberToCurrencyCommas,
  getCurrencySymbol,
} from 'components/FormatPrice/helpers'

export const getPriceLabel = (selectedCurrency: LocaleCurrency, priceValue: string): string => {
  const currencySymbol = getCurrencySymbol(selectedCurrency)

  const priceMappingObject = {
    '0-500': `Under ${currencySymbol}500`,
    '0-200': `Under ${currencySymbol}200`,
    '500': `Over ${currencySymbol}500`,
    '10000-500000': `Over ${currencySymbol}10,000`,
  }

  const splitPrice = priceValue.split('-')
  const price = splitPrice.map((value) =>
    convertDefaultToLocaleCurrency(parseInt(value, 10), selectedCurrency)
  )
  const priceString = price.join('-')

  const priceTitle = Object.keys(priceMappingObject).some((priceKey) => priceKey === priceString)
    ? priceMappingObject[priceString]
    : `${currencySymbol}${formatNumberToCurrencyCommas(
        price[0],
        selectedCurrency.locale
      )} - ${currencySymbol}${formatNumberToCurrencyCommas(price[1], selectedCurrency.locale)}`

  return priceTitle
}

export const getPriceWithCurrencySymbol = (
  selectedCurrency: LocaleCurrency,
  priceValue: string
): string => {
  const currencySymbol = getCurrencySymbol(selectedCurrency)
  const splitPrice = priceValue.split('-')
  const priceTitle = `${currencySymbol}${formatNumberToCurrencyCommas(
    Number(splitPrice[0]),
    selectedCurrency.locale
  )} - ${currencySymbol}${formatNumberToCurrencyCommas(
    Number(splitPrice[1]),
    selectedCurrency.locale
  )}`

  return priceTitle
}
